import { makeStyles, Tab, Tabs } from '@material-ui/core'
import classNames from 'classnames'
import React from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import HomeIcon from './home-icon'

export const CustomerTabs = ({ locations, children }) => {
    const tabs = makeTabs(locations)

    const [currentTab, setCurrentTab] = useState(tabs[0].customerId)
    const { theme } = useSelector(state => state.main)

    const styles = useStyles()
    return (
        <div className={styles.root}>
            <Tabs
                orientation="vertical"
                classes={{ indicator: styles.tabIndicator }}
                value={currentTab}
                className={styles.tabs}
                onChange={(_, newTab) => setCurrentTab(newTab)}
                centered
            >
                {tabs?.map(t => {
                    const isSelected = t.customerId === currentTab
                    return (
                        <Tab
                            key={t.customerId}
                            label={
                                <div
                                    className={classNames(styles.tab, {
                                        [styles.tabActive]: isSelected
                                    })}
                                >
                                    {t.isOriginal && (
                                        <HomeIcon
                                            className={styles.icon}
                                            color={
                                                isSelected
                                                    ? theme.primary
                                                    : theme.textSecondary
                                            }
                                        />
                                    )}
                                    {t.customerName}
                                </div>
                            }
                            value={t.customerId}
                        />
                    )
                })}
            </Tabs>
            <div className={styles.locationsWrapper}>
                {children(currentTab)}
            </div>
        </div>
    )
}

const makeTabs = l => {
    const tabs = []
    for (const customerId of Object.keys(l)) {
        tabs.push({
            customerId,
            customerName: l[customerId].customer_name,
            isOriginal: l[customerId].is_original
        })
    }
    // original locations needs to be first
    return tabs.sort(a => (a.isOriginal ? -1 : 1))
}

const useStyles = makeStyles(theme => ({
    tab: {
        fontSize: 13,
        textTransform: 'none',
        fontWeight: 700,
        color: theme.textSecondary,
        fontFamily: theme.fontFamily,
        display: 'flex',
        alignItems: 'center'
    },
    locationsWrapper: {
        height: '100%',
        width: 500,
        marginLeft: 8
    },
    tabIndicator: {
        backgroundColor: theme.primary,
        height: 3
    },
    tabs: {
        // borderBottom: theme.border
    },
    tabActive: {
        color: theme.primary
    },
    icon: {
        marginRight: 8
    },
    root: {
        marginTop: 16,
        height: '100%',
        display: 'flex'
    }
}))
